import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import StyleTaskModalPage from '../../../containers/masters/StyleTask/StyleTaskModalPage'
import { styleTasksIds } from '../../../constants/backendIds'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class StyleTaskMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchName: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchStyleTaskList()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchStyleTaskList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchStyleTaskList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  searchStyleTask () {
    this.props.actions.fetchStyleTaskList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  applyStyleTask (task) {
    switch (task.styleTaskCssId) {
      case styleTasksIds.Normal:
        return ''
      case styleTasksIds.Bold:
        return 'activebold'
      case styleTasksIds.BoldBlue:
        return 'activeboldblue'
      case styleTasksIds.BoldRed:
        return 'activeboldred'
    }
  }

  resetFilters () {
    this.setState({
      filter: {
        searchName: null
      }
    }, () => { this.searchStyleTask() })
  }

  render () {
    const {
      t, styleTaskList, pagesCount, styleTaskListCount, filter,
      filter: { page },
      actions: { openStyleTaskModal, fetchStyleTaskList, deleteStyleTask }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'styleTasksMasterPage' })

    const tKey = 'MASTERS.STYLE_TASK_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT_TOOLTIP`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE_TOOLTIP`)}</Tooltip>)
    const hasFilters = this.state.filter.searchName
    return (
      <div id="styleTaskMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.searchName"
                controlLabel={t(`${tKey}SEARCH_BY`)}
                placeholder={t(`${tKey}SEARCH_BY`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchStyleTask()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t('ADMIN.SEARCH_BTN')}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('order') }}>
                      {t(`${tKey}ORDER`)}
                      <i className={this.getSortIcon('order')} />
                    </th>
                    <th onClick={() => { this.changeOrder('name') }}>
                      {t(`${tKey}NAME`)}
                      <i className={this.getSortIcon('name')} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {styleTaskList && styleTaskList.map((styleTask, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{styleTask.order}</td>
                        <td className={this.applyStyleTask(styleTask)}>{styleTask.name}</td>
                        <td className='actions'>
                          {(
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => openStyleTaskModal(styleTask)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              {styleTask && styleTask.styleTaskCssId !== styleTasksIds.Normal ? (
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn 'onClick={() => deleteStyleTask(styleTask.styleTaskId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              ) : (
                                <></>
                              )}
                            </div>
                          )}
                        </td>
                      </tr>)
                  })}
                </tbody>
              </Table>
              {(styleTaskList === null || styleTaskList === undefined || styleTaskList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={styleTaskListCount}
                    onSelectAction={(value) => fetchStyleTaskList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <StyleTaskModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listStyleTask'
})(StyleTaskMaster)
